module.exports = __webpack_public_path__ + "img/profile.3bc7b7f1.svg";